

// @ts-nocheck

import Vue from "vue";
import { decode } from "../../../../../../../Overarching Resources/TS/Survey/surveyHelperMethods";
import speechbubbles from "./SVGs/Speechbubbles.vue";
import rewards from "./SVGs/Rewards.vue";

export default Vue.extend({
  data() {
    return <
      {
        fieldLocal: string;
        initialOfficialLangEncoded: boolean | string;
        initialOfficialLangPhrase: boolean | string;
      }
    >{
      fieldLocal: "",
      initialOfficialLangEncoded: false,
      initialOfficialLangPhrase: false,
    };
  },
  props: {
    label: String,
    fieldAddress: Array,
    validation: String,
    placeholder: String,
    descriptionTip: {
      type: [String, Boolean],
      default: false,
    },
    description: {
      type: [String, Boolean],
      default: false,
    },
    pic: {
      type: [String, Boolean],
      default: false,
    },
    allowAction: {
      type: Boolean,
      default: true,
    },
  },
  created(): void {
    if (this.field === false) return;

    let decoded = decode(this.field as string);
    if (decoded) {
      //official language field

      this.fieldLocal = this.$store.getters["dash/specificLanguagePack"](
        decoded.languagePackSlug
      )[decoded.slug].replaceAll(
        "[businessname]",
        this.$store.state.dash.viewData.business.businessInfo.businessName
      );

      this.initialOfficialLangEncoded = this.field;

      this.initialOfficialLangPhrase = this.fieldLocal;
    } else {
      this.fieldLocal = this.field;
    }
  },
  computed: {
    field: {
      get: function (): string | false {
        return this.$store.getters["survey/stepField"](this.fieldAddress);
      },
      set: function (v: string): void {
        this.$store.commit("survey/CHANGE_FIELD", {
          fieldAddress: this.fieldAddress,
          val: v,
        });
      },
    },
  },
  watch: {
    fieldLocal(v: string): void {
      // @ts-ignore
      setTimeout(() => {
        // @ts-ignore //errors not picked up
        if (this.errors.any()) {
          this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: true});
        } else {
          this.$emit("handleErrors", {fieldAddress: this.fieldAddress, hasErrors: false});
        }
      }, 1);

      if (this.initialOfficialLangPhrase === v) {
        // @ts-ignore //computed prop type not picked up correctly
        this.field = this.initialOfficialLangEncoded; //if we change it back to the official dictionary item, then record it so in the DB
        //console.log('field set back to original: ' + this.initialOfficialLangEncoded)
      } else {
        this.field = v.trim().length === 0 ? false : v;
      }
    },
  },
  methods: {
    action(): void {
      // @ts-ignore
      this.fieldLocal = "";
    },
  },
  components: {
    speechbubbles,
    rewards,
  },
});
